import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { SelectPesquisavelComponent } from '../../../../../shared/components/select-pesquisavel/select-pesquisavel.component';
import { TagServicoTomadoItemStruct } from '../../../../../shared/services/structs/repo-dfse/tag-servico-tomado-item.struct';

@Component({
  selector: 'app-servico-tomado-dados-adicionais',
  standalone: true,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, SelectPesquisavelComponent],
  templateUrl: './servico-tomado-dados-adicionais.component.html',
})
export class ServicoTomadoDadosAdicionaisComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() listaTags: TagServicoTomadoItemStruct[] = [];
}
